import { canAccess, PERMISSIONS } from './permissions';

export const selectGlobalResources = (
  authorization,
  { accounts, commercial, circularityDefaults, auditEvents },
  { isSwitchAccount = false } = {},
) => {
  const resources = [];
  if (canAccess(authorization, PERMISSIONS.ACCOUNTS_SWITCH)) {
    resources.push(accounts());
  }
  if (authorization?.userType === 'INTERNAL') {
    if (!isSwitchAccount) resources.push(...commercial());
    if (auditEvents) resources.push(auditEvents());
  }
  if (
    circularityDefaults &&
    canAccess(authorization, PERMISSIONS.AUTOMATION_CONFIGURE)
  ) {
    resources.push(circularityDefaults());
  }
  return resources;
};
